module.exports = __webpack_public_path__ + "img/p72.2ef88f75.png";